export default __webpack_public_path__ + "7b4456f28c0ed021dc5dbb55c59048ec.svg";